import React, { Component } from 'react';
import FAQCategory from '../../../../src/models/FAQCategory';
import { select } from 'react-cookies';

type FAQCategoryListItemViewProps = {
    category: FAQCategory,
    categorySelected: (category: FAQCategory) => void,
    isSelected: boolean,
    first: boolean,
    last: boolean
}

export default class FAQCategoryListItemView extends Component<FAQCategoryListItemViewProps> {
    constructor(props: FAQCategoryListItemViewProps) {
        super(props);
    }

    public selectCategory() {
        this.props.categorySelected(this.props.category);
    }

    public render() {
        const imageStyle = {
            width: '40px'
        };

        if (this.props.category.url) {
            const formattedUrl = this.props.category.url.replace(/^~\//, '/');
            return (
                <a href={formattedUrl} className={"p-3 text-dark-blue text-left btn-no-styling w-100 d-block "
                    + (this.props.first ? "rounded-top" : "border-top")
                    + (this.props.last ? " rounded-bottom" : "")
                    + (this.props.isSelected ? " bg-white" : "")}>
                    <img src={this.props.category.iconSrc} className="mr-3" style={imageStyle} alt=""></img>
                    <strong>{this.props.category.title}</strong>
                </a>
            )
        }

        return (
            <button className={"p-3 text-dark-blue text-left btn-no-styling w-100 "
                + (this.props.first ? "rounded-top" : "border-top")
                + (this.props.last ? " rounded-bottom" : "")
                + (this.props.isSelected ? " bg-white" : "")}
                onClick={() => this.selectCategory()}
                type="button"
            >
                <img src={this.props.category.iconSrc} className="mr-3" style={imageStyle} alt=""></img>
                <strong>{this.props.category.title}</strong>
            </button >
        );
    }
}